import { render } from "./join.vue?vue&type=template&id=0a2baee1&scoped=true&ts=true"
import script from "./join.vue?vue&type=script&lang=ts&config=true"
export * from "./join.vue?vue&type=script&lang=ts&config=true"

import "./join.vue?vue&type=style&index=0&id=0a2baee1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2baee1"]])

export default __exports__